import type { ButtonHTMLAttributes, ReactNode } from "react";
import joinClassNames from "../../utils/joinClassNames";

import "./hearingTestButton.scss";

type HearingTestButtonProps = Omit<ButtonHTMLAttributes<HTMLButtonElement>, "children"> & {
  children: ReactNode;
  iconClassName: string;
};

export default function HearingTestButton({
  children,
  iconClassName,
  className,
  type = "button",
  ...props
}: HearingTestButtonProps) {
  return (
    <button type={type} className={joinClassNames("hearing-test-button", className)} {...props}>
      <i className={joinClassNames(iconClassName, "hearing-test-button__icon")} aria-hidden="true" />
      <span>{children}</span>
    </button>
  );
}